import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PAGE } from 'src/app/routes';
import { UserStateService } from '../services/user-state/user-state.service';
import { environment } from 'src/environments/environment';

export const onboardingGuard: CanActivateFn = () => {
  const onboarded = inject(UserStateService).onboarded;
  if (onboarded) {
    return true;
  } else {
    if (environment.telegram) {
      inject(Router).navigate([PAGE.TELEGRAM_ONBOARD]);
      return false;
    } else {
      inject(Router).navigate([PAGE.ACCOUNT]);
      return false;
    }
  }
};
